<!--
 * @Description: 护工用户配置组件
 * @Author: gaohc, fengal
 * @Date: 2022-11-02 16:43:52
-->
<template>
  <div class="attendant-body">
    <el-card class="box-card" shadow="never" :body-style="{padding: '0px', 'background-color': '#FAFBFF',}">
      <div class="box-card-left-main">
        <div class="box-card-header">
          <span style="font-weight: bold">
            {{title}}
          </span>
          <img src="../../../../assets/hsvccfg/add-plus.png" @click="handleAddAttendant" alt="" style="width: 15px; 
            padding-top: 3px; cursor: pointer" />
        </div>
        <el-table :data="attendantList" :show-header="false" :highlight-current-row="true" :row-class-name="tableRowClassNameOfAttendant" 
          @cell-mouse-enter="handleMouseEnterAttendantCell" @cell-mouse-leave="handleMouseLeaveAttendantCell">
          <el-table-column label="" min-width="60%">
            <template slot-scope="scope">
              <span>
                {{scope.row.certText}}
                {{scope.row.labelText}}
              </span>
            </template>
          </el-table-column>
          <el-table-column align="right" min-width="40%">
            <template slot-scope="scope" v-if="selectedAttendantIndex == scope.row.index">
              <img width="16px" height="16px" class="img-edit mouse-pointer" src="@/assets/syscfg/icon-usercfg-edit.png"
                @click="handleEditAttendant(scope.$index, scope.row)" alt="" />
              <img width="16px" height="16px" class="img-delete mouse-pointer" src="@/assets/syscfg/icon-usercfg-delete.png"
                @click="handleDeleteAttendant(scope.$index, scope.row)" alt="" />
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>
  </div>
</template>

<script>

export default {
  name: 'AttendantCfg',
  props: ['title', 'attendantList'],
  data() {
    return {
      selectedAttendantIndex: -1,
    }
  },

  methods: {
    tableRowClassNameOfAttendant({row, rowIndex}) {
      row.index = rowIndex
    },

    handleMouseEnterAttendantCell(row) {
      this.selectedAttendantIndex = row.index
    },

    handleMouseLeaveAttendantCell() {
      this.selectedAttendantIndex = -1
    },

    //新增
    handleAddAttendant() {
      this.$emit('add-attendant', this.title)
    },

    //编辑
    handleEditAttendant(_index, row) {
      this.$emit('edit-attendant', this.title, row)
    },
    
    //删除
    handleDeleteAttendant(_index, row) {
      this.$emit('delete-attendant', row)
    },
  },
}
</script>

<style scoped>
.body {
  margin: 0;
  text-align: center;
  border: solid 0px;
}

.attendant-body {
  margin: 0;
  text-align: left;
  border: solid 0px;
}

.attendant-body /deep/ .el-table {
  max-height: 260px;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: #fafbff;
  min-height: 160px;
}

.attendant-body /deep/ .el-table .el-table__row {
  background-color: #fafbff;
}

.attendant-body /deep/ .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  border-bottom: 0;
}

.attendant-body /deep/ .el-table .cell {
  padding-left: 20px;
}

.attendant-body .box-card-header {
  padding: 0 20px;
  height: 45px;
  background-color: white;
  font-size: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.attendant-body .img-edit {
  margin: 0 15px 0 0;
}

.attendant-body .img-delete {
  margin: 0px 5px 0 0;
}

.attendant-body .tag-color {
  vertical-align: middle;
  width: 33px;
  height: 17px;
  border-width: 0;
}

.attendant-body .tag-text {
  border-width: 0;
  vertical-align: middle;
}

.attendant-body .el-table__row > td {
  border: none;
}

.attendant-body .el-table::before {
  height: 0px;
}

.attendant-body .el-table__empty-block {
  background-color: #fafbff;
}
</style>



// WEBPACK FOOTER //
// src/components/syscfg/components/usercfg/AttendantCfg.vue